module.exports = __webpack_public_path__ + "img/MGH-Roppongi-5.4de184bd.jpg";